import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Flex, Box } from 'grid-styled';
import { ThemeProvider } from 'styled-components';
import connect from '../store/connect';
import { color, size } from '../styles/helpers/variables';
import { StartPageBlock } from '../styles/blocks/StartPageBlock';
import { fetchInstagramPosts } from '../actions/actionCreators';
import LinedHeading from '../components/LinedHeading';
import InstagramPost from '../components/InstagramPost';
import { INSTAGRAM_API_URL } from '../constants/endpoints';

class InstagramSection extends PureComponent {
  componentDidMount() {
    this.props.fetchInstagramPosts({ endpointUrl: INSTAGRAM_API_URL });
  }

  renderInstagramPosts() {
    return this.props.instagram
      .map(post => {
        const imageUrl = post.getIn(['images', 'standard_resolution', 'url']);
        return (
          <Box key={post.get('id')} width={[1 / 2, 1 / 2, 1 / 4]} p={['5px', '8px', '11px']}>
            <InstagramPost url={post.get('link')} imageUrl={imageUrl} />
          </Box>
        );
      })
      .toArray();
  }

  render() {
    const { viewstate } = this.props;
    const instagramPosts = this.renderInstagramPosts();

    return (
      <StartPageBlock.Section
        backgroundColor={color.lightBlack}
        pt={viewstate.get('pageWidth') <= size.large ? 30 : 35}
        pb={viewstate.get('pageWidth') <= size.large ? 60 : 100}
      >
        <StartPageBlock.Container bgColor={color.lightBlack}>
          <LinedHeading color={color.white} noBottomMargin>
            Följ oss på Instagram
          </LinedHeading>
          <StartPageBlock.InstagramHashTag href="https://www.instagram.com/valamagasinet/" target="_blank">
            @valamagasinet
          </StartPageBlock.InstagramHashTag>
          <ThemeProvider
            theme={{
              breakpoints: ['500px', '730px', '800px', '1200px']
            }}
          >
            <Flex flexWrap="wrap" mx={['-5px', '-8px', '-11px']}>
              {instagramPosts}
            </Flex>
          </ThemeProvider>
        </StartPageBlock.Container>
      </StartPageBlock.Section>
    );
  }
}

InstagramSection.defaultProps = {
  viewstate: Map(),
  instagram: Map()
};

InstagramSection.propTypes = {
  viewstate: PropTypes.instanceOf(Map),
  instagram: PropTypes.instanceOf(Map),
  fetchInstagramPosts: PropTypes.func.isRequired
};

export default connect(InstagramSection, { fetchInstagramPosts }, store => ({
  viewstate: store.viewstate,
  instagram: store.instagram
}));



// WEBPACK FOOTER //
// ./src/components/InstagramSection.js